export default {
  metadata: {
    version: '1.0.0',
    id: 'search-results-1.0.0',
    name: 'JDSSearchResultsInternal'
  },
  hierarchy: {
    'root-container': [
      {
        container: [
          {
            'heading-container': ['jds-text', 'jds_action_button']
          },
          {
            'results-container': ['jds_search_result_item']
          }
        ]
      }
    ]
  },
  base: {
    'root-container': {
      'background-color': '{primaryBackground}',
      'flex-direction': '{flexDirection.column}',
      'align-items': '{alignItems.center}',
      'padding-top': '{base}',
      'padding-right': '{base}',
      'padding-bottom': '{base}',
      'padding-left': '{base}',
      gap: '{base}',
      width: '{size.max}'
    },
    container: {
      width: '{size.max}',
      'flex-direction': '{flexDirection.column}',
      'align-items': '{alignItems.center}'
    },
    'heading-container': {
      'flex-direction': '{flexDirection.row}',
      'justify-content': '{justifyContent.spaceBetween}',
      'align-items': '{alignItems.start}',
      width: '{size.max}'
    },
    jds_action_button: {
      kind: 'tertiary',
      size: 'small',
      appearance: 'normal',
      state: 'normal',
      iconPosition: 'left',
      stretch: false
    },
    'results-container': {
      'flex-direction': '{flexDirection.column}',
      'align-items': '{alignItems.start}',
      gap: '{base}',
      width: '{size.max}'
    },
    'jds-text': {
      'font-family': '{text_86}',
      color: '{text_20}',
      'font-size': '{text_85}',
      'line-height': '{text_87}',
      'letter-spacing': '{text_88}',
      'font-weight': '{text_89}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    appearance: {
      box: {
        'root-container': {
          'border-radius': '{xl}',
          'box-shadow': {
            x: 0,
            y: 4,
            blur: 16,
            spread: 0,
            color: '#00000014'
          }
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      appearance: {
        values: ['normal', 'box'],
        doc_description:
          "This determines the appearance of search results, it can be 'normal or 'box'."
      }
    },
    data: {
      container: {
        'max-width': {
          type: 'size',
          name: 'maxWidth'
        }
      },
      jds_action_button: {
        label: {
          type: 'string',
          name: 'headerAction',
          doc_description:
            'If this is passed a button will appear on the right side of the Heading in the Header.'
        }
      },
      'results-container': {
        value: {
          type: 'list',
          name: 'results',
          function: true,
          object: {
            icon: 'icon',
            label: 'string'
          }
        }
      },
      jds_search_result_item: {
        label: {
          type: 'string',
          name: 'results.label'
        },
        icon: {
          type: 'icon',
          name: 'results.icon'
        },
        query: {
          type: 'string',
          name: 'query'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'header',
          doc_description:
            'It is a heading that will display in the Header of the SearchResults.'
        }
      }
    },
    events: {
      'root-container': {
        onAppear: {
          name: 'onAppear',
          platform: 'ios'
        }
      },
      jds_search_result_item: {
        onClick: 'onClick'
      },
      jds_action_button: {
        onClick: 'onHeaderActionClick'
      },
      container: {
        onClick: 'onContainerClick'
      }
    },
    a11y: {
      jds_action_button: {
        ariaLabel: 'headerActionAriaLabel',
        ariaDescribedby: {
          name: 'headerActionAriaDescribedby',
          platform: 'web,ios'
        }
      },
      'results-container': {
        name: 'results',
        properties: {
          role: {
            value: 'list'
          }
        },
        repeating: {
          ariaLabel: 'resultAriaLabel',
          ariaDescribedby: {
            name: 'resultAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_search_result_item: {
        properties: {
          ariaLabel: 'results.resultAriaLabel',
          ariaDescribedby: 'results.resultAriaDescribedby'
        }
      }
    }
  }
};
